module.exports = __webpack_public_path__ + "static/media/French_Francois BG-24.27d6e69c.png";